import * as myLocales from '../common/locales';
import acceptLanguage from 'accept-language';
import { getQueryParams } from '../common/util/QueryParams';

let query = '';
//eslint-disable-next-line no-undef
if (!global) {
	query = getQueryParams(document.location.search);
}

let languages = [myLocales.DEFAULT_LOCALE];

if (typeof window === 'object' && 'navigator' in window) {
    languages = navigator.languages ? navigator.languages.join(', ') : navigator.language;
}
acceptLanguage.languages(Object.keys(myLocales.getSupportedLocales()));

let locale = query.lang ? query.lang : 'en';

if (typeof window === 'object' && 'localStorage' in window) {
    locale = localStorage.getItem('locale');
}

// lang can be set up on web and stored in cookie
//eslint-disable-next-line no-undef
if (!locale && !global) {
    document.cookie.split(';').filter((cookie) => {
        return 0 === cookie.trim().indexOf('custom_lang');
    }).some((item) => {
        let values = item.split('=');
        locale = values[1];
        return true;
    });
}

if (!locale || !myLocales.getSupportedLocales()[locale]) {
    locale = acceptLanguage.get(languages);
}

export function getLocale() {
    return locale;
}

export function setLocale(newLocale) {
    locale = newLocale;

    if (typeof window === 'object' && 'localStorage' in window) {
		localStorage.setItem('locale', newLocale);
	}
}

export function getMyCurrency() {
    if (locale === 'en') {
        return 'EUR';
    } else {
        return 'CZK';
    }
}
